"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerAccountGA4NotificationMessage = void 0;
var CustomerAccountGA4NotificationMessage;
(function (CustomerAccountGA4NotificationMessage) {
    CustomerAccountGA4NotificationMessage["NotPaid"] = "nicht bezahlt";
    CustomerAccountGA4NotificationMessage["Cancelled"] = "storniert";
    CustomerAccountGA4NotificationMessage["ProductNotAvailable"] = "Produkt nicht verf\u00FCgbar";
})(CustomerAccountGA4NotificationMessage || (exports.CustomerAccountGA4NotificationMessage = CustomerAccountGA4NotificationMessage = {}));
//# sourceMappingURL=CustomerAccountGa4NotificationMessage.js.map